import React from "react";
import EmailEditor from "./EmailEditor";

const ComposeEmail = () => {
  return (
    <div className="composeEmail">
      <EmailEditor isDraft={false} isDialogView={false}/>
    </div>
  );
};

export default ComposeEmail;
